import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "toggleOn", "toggleOff"]

  connect() {
    this.render()
    $(this.toggleTarget).on("change", () => this.render())
  }

  render() {
    this.toggleTarget.checked ? this.renderOn() : this.renderOff()
  }

  renderOn() {
    if (this.hasToggleOnTarget) {
      $(this.toggleOnTarget).removeClass("hidden")
    }
    if (this.hasToggleOffTarget) {
      $(this.toggleOffTarget).addClass("hidden")
    }
  }

  renderOff() {
    if (this.hasToggleOnTarget) {
      $(this.toggleOnTarget).addClass("hidden")
    }
    if (this.hasToggleOffTarget) {
      $(this.toggleOffTarget).removeClass("hidden")
    }
  }
}
